import React from 'react';
import { Polygon, Polyline, Marker } from "react-google-maps";
import { useDispatch, useSelector } from "react-redux";
import { onShowQuyHoachInfoPanel, mapGeoType } from "../../Containers/QuyHoach";
import Type from "../../Redux/Type";
import PointLayer from './Layers/PointLayer';
import PolygonLayer from './Layers/PolygonLayer';


const LopQuyHoach = () => {
    const { showQuyHoach, polyline, labelActive, selected } = useSelector(state => state.quyHoach);
    const dispatch = useDispatch();
    const onPolygonPress = (e) => {
        // console.log(e)
        dispatch({ type: Type.SET_STATE_RIGHT_PANEL, route: 'isMinimized', value: false });
        dispatch({ type: Type.SELECTED_QUYHOACH, value: e })
        onShowQuyHoachInfoPanel();
    }
    const onPolygonPressLayer = (e) => {
        dispatch({ type: Type.SET_STATE_RIGHT_PANEL, route: 'isMinimized', value: false });
        dispatch({ type: Type.SELECTED_QUYHOACH, value: e })
        onShowQuyHoachInfoPanel();
    }
    return (
        <div>
            {showQuyHoach ?
                <PolygonLayer onClickEvnt={(e) => onPolygonPressLayer(e)} />
                :
                null
            }
            {showQuyHoach ?
                polyline.map((e) => (
                    <Polyline
                        key={e.ID}
                        path={e['polygon']}
                        options={{
                            strokeColor: e.strokeColor,
                            strokeWeight: e.weightLine,
                            zIndex: 500
                        }}
                        visible={labelActive.includes(e['label'])}
                        onClick={() => onPolygonPress(e)}
                    />
                ))
                : null
            }
            {showQuyHoach ?
                // <MarkerClusterer
                //     averageCenter
                //     enableRetinaIcons
                //     gridSize={60}
                // >
                <PointLayer onClickEvnt={(e) => onPolygonPressLayer(e)} />
                : null
            }
            {selected.geoType === mapGeoType.POLYGON ?
                <Polygon
                    paths={selected['polygon']}
                    defaultPath={[]}
                    options={{
                        strokeColor: '#76FF03',
                        fillColor: '#76FF03',
                        strokeWeight: 3,
                        zIndex: 1000
                    }}
                // editable={true} 
                />
                :
                selected.geoType === mapGeoType.LINESTRING ?
                    <Polyline
                        path={selected['polygon']}
                        options={{
                            strokeColor: '#76FF03',
                            strokeWeight: 3,
                            zIndex: 1000
                        }}
                        zIndex={2000}
                    />
                    :
                    selected.geoType === mapGeoType.POINT ?
                        <Marker
                            position={selected['polygon']}
                            zIndex={2000}
                        />
                        : null
            }
        </div>
    )
}

export default LopQuyHoach
